const calculator = () => {

    const tariffs = {
        'day-1': {name: '1 day', days: 1, percent: 0.3},
        'day-5': {name: '5 days', days: 5, percent: 2},
        'day-10': {name: '10 days', days: 10, percent: 5},
        'day-20': {name: '20 days', days: 20, percent: 12},
        'day-30': {name: '30 days', days: 30, percent: 22.5},
        core: {name: 'Core', days: 200, percent: 220},
        elite: {name: 'Elite', days: 200, percent: 260},
    };

    const form = document.querySelector('.calc');
    if (!form) return;

    const amountInput = form.querySelector('input[name="input"]');
    const paymentRadios = form.querySelectorAll('input[name="payments"]');

    const valueEl = form.querySelector('.calc-result__value');
    const topAlert = form.querySelector('.calc-alert:not(.calc-alert--bottom)');

    const resultItems = form.querySelectorAll('.result__list .result__item');
    const contribEl = resultItems[0]?.querySelector('.result__right');
    const deltaEl = resultItems[1]?.querySelector('.result__right');

    const barLine = form.querySelector('.result-bar__line');

    const gridItems = form.querySelectorAll('.result__grid .result__items');
    const termNameEl = gridItems[0]?.querySelector('.result__name');
    const percentNameEl = gridItems[1]?.querySelector('.result__name');

    const fmt = (n) => (isNaN(n) || n == null ? '0' : String(n).replace(
        /\B(?=(\d{3})+(?!\d))/g, ' '));
    const parse = (s) => (!s || typeof s !== 'string' ? 0 : parseInt(
        s.replace(/\D/g, '')) || 0);
    const sel = (name) => form.querySelector(`input[name="${name}"]:checked`);

    const fmtPercent = (p) => `+${String(p).replace('.', ',')}%`;

    function daysWord(n) {
        const n10 = n % 10, n100 = n % 100;
        if (n100 >= 11 && n100 <= 14) return 'days';
        if (n10 === 1) return 'day';
        if (n10 >= 2 && n10 <= 4) return 'days';
        return 'days';
    }

    const daysLabel = (n) => `${n} ${daysWord(n)}`;

    function uncheckPayments() {
        paymentRadios.forEach((r) => { r.checked = false; });
    }

    function calculate() {
        const tariffInput = sel('tariffs');
        const config = tariffInput ? tariffs[tariffInput.value] : null;
        const amount = parse(amountInput?.value);

        if (!config || !amount) {
            if (valueEl) valueEl.textContent = '0';
            if (topAlert) topAlert.lastChild
                ? (topAlert.lastChild.textContent = ' Upon completion: —')
                : (topAlert.textContent = 'Upon completion: —');
            if (contribEl) contribEl.textContent = fmt(amount);
            if (deltaEl) deltaEl.textContent = '+0';
            if (barLine) barLine.style.width = '0%';
            if (termNameEl) termNameEl.textContent = config ? daysLabel(
                config.days) : '—';
            if (percentNameEl) percentNameEl.textContent = config ? fmtPercent(
                config.percent) : '+0%';
            return;
        }

        const payout = Math.floor(
            Math.round(amount * (1 + config.percent / 100) * 100) / 100);
        const delta = payout - amount;
        const term = daysLabel(config.days);

        if (valueEl) valueEl.textContent = fmt(payout);

        if (topAlert) {
            // сохраняем svg-иконку внутри .calc-alert, меняем только текст
            const textNode = Array.from(topAlert.childNodes).find(
                n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = ` По завершении: ${term}`;
            else topAlert.append(` По завершении: ${term}`);
        }

        if (contribEl) contribEl.textContent = fmt(amount);
        if (deltaEl) deltaEl.textContent = `+${fmt(delta)}`;

        if (barLine) {
            const ratio = payout > 0 ? Math.min(100,
                Math.max(0, (delta / payout) * 100)) : 0;
            barLine.style.width = `${ratio}%`;
        }

        if (termNameEl) termNameEl.textContent = term;
        if (percentNameEl) percentNameEl.textContent = fmtPercent(
            config.percent);
    }

    amountInput?.addEventListener('input', function() {
        const digits = this.value.replace(/\D/g, '');
        const amount = digits ? parseInt(digits) : 0;
        this.value = amount ? fmt(amount) : '';
        uncheckPayments();
        calculate();
    });

    amountInput?.addEventListener('keydown', (e) => {
        const allowed = new Set([46, 8, 9, 27, 13, 37, 38, 39, 40]);
        const isNum = (e.keyCode >= 48 && e.keyCode <= 57) ||
            (e.keyCode >= 96 && e.keyCode <= 105);
        const isCtrl = e.ctrlKey && [65, 67, 86, 88].includes(e.keyCode);
        if (!allowed.has(e.keyCode) && !isNum && !isCtrl) e.preventDefault();
    });

    amountInput?.addEventListener('paste', function(e) {
        e.preventDefault();
        const digits = (e.clipboardData ?? window.clipboardData).getData(
            'text').replace(/\D/g, '');
        if (!digits) return;
        uncheckPayments();
        this.value = fmt(parseInt(digits));
        calculate();
    });

    paymentRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
            if (!radio.checked || !amountInput) return;
            amountInput.value = fmt(parseInt(radio.value, 10));
            calculate();
        });
    });

    form.addEventListener('change', ({target}) => {
        if (target.name === 'tariffs') calculate();
    });

    calculate();
};

export default calculator;
